<template>
  <div>
    <main role="primary">
      <section class="home-section section--1 row expanded align-middle align-right" :style="{height: `${sectionHeight}px`}">
        <transition name="fade" mode="out-in">
          <div class="mxr-video" v-if="showVid">
            <div class="mxr-video__inner">
              <video id="vklnj" class="v-klnj">
                <source v-if="videoSrc" :src="videoSrc" :type="videoType" />
              </video>
            </div>
          </div>
        </transition>
        <div class="column shrink mxr-logo__wrap">
          <img src="../assets/img/mix-and-run.svg" class="mxr-logo" width="280" alt="Mix &amp; Run" id="mxr-logo">
        </div>
        <div class="mxr-video-sneak show-for-large" @click="createVideo">
          <div class="mxr-video-sneak__icon">
            <i class="zmdi zmdi-play"></i>
          </div>
          <span>Guarda il video</span>
        </div>
        <div class="light"></div>
        <div class="icon-scroll"></div>
      </section>
      <div id="pinContainer" :style="{height: `${sectionHeight}px`}">
        <div id="storyContainer">
          <section class="panel panel--freedom">
            <div class="light"></div>
            <div class="panel__picture"> 
              <div class="filter"></div>
            </div>
            <div class="word">
              <span>F</span>
              <span>r</span>
              <span>e</span>
              <span>e</span>
              <span>d</span>
              <span>o</span>
              <span>m</span>
            </div>
          </section>
          <section class="panel panel--happiness">
            <div class="light"></div>
            <div class="panel__picture">
              <div class="filter"></div>
            </div>
            <div class="word">
              <span>H</span>
              <span>a</span>
              <span>p</span>
              <span>p</span>
              <span>i</span>
              <span>n</span>
              <span>e</span>
              <span>s</span>
              <span>s</span>
            </div>
          </section>
          <section class="panel panel--achievement">
            <div class="light"></div>
            <div class="panel__picture">
              <div class="filter"></div>
            </div>
            <div class="word">
              <span>A</span>
              <span>c</span>
              <span>h</span>
              <span>i</span>
              <span>e</span>
              <span>v</span>
              <span>e</span>
              <span>m</span>
              <span>e</span>
              <span>n</span>
              <span>t</span>
            </div>
          </section>
        </div>
      </div>
      <div class="section--hf row expanded align-middle collapse" :style="{height: `${sectionHeight}px`}">
        <div class="section--women small-12 medium-6 column text-center">
          <router-link to="/looks/women" class="section__inner">
            <div class="section__title">
              <span>Scopri gli outfits</span>
              <strong>Donna</strong>
            </div>
            <div class="section__picture section--women__picture"></div>
          </router-link>
        </div>
        <div class="section--men small-12 medium-6 column text-center">
          <router-link to="/looks/men" class="section__inner">
            <div class="section__title">
              <span>Scopri gli outfits</span>
              <strong>Uomo</strong>
            </div>
            <div class="section__picture section--men__picture"></div>
          </router-link>
        </div>
      </div>
    </main>
    <transition name="fade" mode="out-in">
      <borders :show-corners="!showVid" :show-text="true" :show-dots="true"></borders>
    </transition>
  </div>
</template>

<script>
  import borders from '@/components/Borders';
  import ScrollMagic from 'scrollmagic';
  import { TimelineMax, TweenMax, Power4, Power2 } from 'gsap';
  import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
  import plyr from 'plyr';
  import utils from '../utils';

  export default {
    name: 'home',
    components: { borders, plyr, TweenMax, ScrollMagic },
    data() {
      return {
        showVid: false,
        videoSrc: 'https://www.decathlon.fr/ecfr/static/concept/kalenji/mnr/static/klnj.mp4',
        videoType: 'video/mp4',
        player: null,
        sectionHeight: '',
        plyrOptions: {
          volume: 5,
          autoplay: true,
          clickToPlay: false,
          controls: ['mute'],
        },
      };
    },
    methods: {
      createVideo() {
        this.showVid = true;
      },
      setAnim() {
        const borderWidth = utils.outerHeight(document.getElementsByClassName('mxr-l-borders--top')[0]);
        if (!utils.isTouchDevice) {
          window.onresize = () => {
            this.sectionHeight = utils.getBorderedViewport();
          };
        }
        // Animation
        const controller = new ScrollMagic.Controller();
        const intro = new TimelineMax()
          .fromTo('#mxr-logo', 1,
            { y: -30, autoAlpha: 0 },
            { y: 0, autoAlpha: 1, ease: Power4.easeInOut },
            )
          .fromTo('.section--1 .light', 2,
            { height: '100%', width: '20%', autoAlpha: 0 },
            { height: '100%', width: '70%', autoAlpha: 1, ease: Power4.easeInOut },
            )
          .fromTo('.section--1 .icon-scroll', 1,
            { y: 250, autoAlpha: 0 },
            { y: 0, autoAlpha: 1 },
          );
        new ScrollMagic.Scene({
          triggerElement: '.section--1',
        })
          .setTween(intro) // trigger a TweenMax.to tween
          .addTo(controller);

        const wipeAnimation = new TimelineMax()

        .fromTo('.panel--freedom .light', 1,
          { height: '100%', width: '50%', autoAlpha: 0, xPercent: '-50%' },
          { height: '100%', width: '30%', autoAlpha: 0.9, xPercent: '0' },
          )
        .staggerFromTo('.panel--freedom .word span', 0.5,
          { y: 120, autoAlpha: 0, scale: 1.4 },
          { y: 0, autoAlpha: 1, scale: 1 },
          0.15,
          )
        .to('.panel--freedom .panel__picture .filter', 1, { autoAlpha: 0 })
        .to('.panel--freedom .light', 1.2, { autoAlpha: 0, xPercent: '-50%', delay: -1.5 })

        .to('.panel--freedom .panel__picture', 5, { scale: 1.1, delay: -3.2, ease: Power2.easeInOut })
        // animate to second panel
        .to('#storyContainer', 0.5, { z: -200, delay: 1 })    // move back in 3D space
        .to('#storyContainer', 2, { x: '-33.3333333%', ease: Power2.easeInOut })  // move in to first panel
        .to('#storyContainer', 0.5, { z: 0 })       // move back to origin in 3D space

        .fromTo('.panel--happiness .light', 1,
          { height: '100%', width: '50%', autoAlpha: 0, xPercent: '50%' },
          { height: '100%', width: '30%', autoAlpha: 0.9, xPercent: '0' },
          )
        .staggerFromTo('.panel--happiness .word span', 0.5,
          { y: 120, autoAlpha: 0, scale: 1.4 },
          { y: 0, autoAlpha: 1, scale: 1 },
          0.15,
          )
        .to('.panel--happiness .panel__picture .filter', 1, { autoAlpha: 0 })
        .to('.panel--happiness .light', 1.2, { autoAlpha: 0, xPercent: '50%', delay: -1.5 })
        .to('.panel--happiness .panel__picture', 5, { scale: 1.1, delay: -3.2, ease: Power2.easeInOut })

        // animate to third panel
        .to('#storyContainer', 0.5, { z: -200, delay: 1 })
        .to('#storyContainer', 2, { x: '-66.6666666%', ease: Power2.easeInOut })
        .to('#storyContainer', 0.5, { z: 0 })

        .fromTo('.panel--achievement .light', 1,
          { height: '100%', width: '50%', autoAlpha: 0, xPercent: '50%' },
          { height: '100%', width: '30%', autoAlpha: 0.9, xPercent: '0' },
          )
        .staggerFromTo('.panel--achievement .word span', 0.5,
          { y: 120, autoAlpha: 0, scale: 1.4 },
          { y: 0, autoAlpha: 1, scale: 1 },
          0.15,
          )
        .to('.panel--achievement .panel__picture .filter', 1, { autoAlpha: 0 })
        .to('.panel--achievement .light', 1.2, { autoAlpha: 0, xPercent: '-50%', delay: -1.5 })
        .to('.panel--achievement .panel__picture', 5, { scale: 1.1, delay: -3.2, ease: Power2.easeInOut })
        .to('.mxr-l-borders__vtext', 1, { autoAlpha: 0, ease: Power2.easeInOut });

        if (document.getElementById('pinContainer').length !== 0) {
          new ScrollMagic.Scene({
            triggerElement: '#pinContainer',
            triggerHook: 'onLeave',
            offset: `-${borderWidth}`,
            duration: '400%',
          })
          .setPin('#pinContainer')
          .setTween(wipeAnimation)
          .addTo(controller);
        }
      },
    },
    mounted() {
      this.$store.commit('hideCart');
      this.$store.commit('showBorders');
      this.sectionHeight = utils.getBorderedViewport();
      if (this.$route.name === 'home') {
        this.setAnim();
      }
    },
    updated() {
      this.player = plyr.setup(document.querySelector('#vklnj'), this.plyrOptions)[0];
      if (this.showVid && this.player !== '') {
        this.player.on('ended', (e) => {
          this.player = e.detail.plyr;
          // console.log(e.detail.plyr);
          this.showVid = false;
          // this.player.destroy();
          this.player = '';
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .mxr-video {
    height: 100%;
    width: 100%;
    background: $white;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1;

    &__inner {
      position: relative;
      height: 100%;
      width: 100%;
    }

    &-sneak {
      // background: url('../assets/img/video-sneak.jpg') no-repeat center center / cover;
      position: absolute;
      bottom: rem-calc(30);
      right: rem-calc(20);
      cursor: pointer;
      color: $white;
      font-size: rem-calc(13);
      font-weight: $global-weight-bold;
      display: flex;
      align-items: center;
      @include breakpoint(large) {
        flex-direction: column;
        right: rem-calc(120);
      }      
      &__icon {
        align-items: center;
        justify-content: center;
        display: flex;
        border: rem-calc(2) solid $white;
        border-radius: 99em;
        width: rem-calc(30);
        height: rem-calc(30);
        margin-right: rem-calc(10);
        font-size: rem-calc(14);
        transition: all ease .3s;
        @include breakpoint(large) {
          margin: 0 auto rem-calc(6) auto;
          font-size: rem-calc(34);
          height: rem-calc(60);
          width: rem-calc(60);
        }
        .zmdi {
          margin-left: rem-calc(2);
        }
      }
      span {
        display: inline-block;
      }

      &:hover {
        .mxr-video-sneak__icon {
          transform: scale(1.1);
        }
      }
    }
  } 
  #pinContainer {
    width: 100%;
    // height: 100%;
    overflow: hidden;
    -webkit-perspective: 1000;
       -moz-perspective: 1000;
            perspective: 1000;
    perspective-origin: 50% 50%;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    transform: translateZ(0) translate3d(0, 0, 0);
  }
  #storyContainer {
    width: 300%; /* to contain 4 panels, each with 100% of window width */
    height: 100%;
  }
  .panel {
    height: 100%;
    width: 33.3333333%; /* relative to parent -> 25% of 400% = 100% of window width */
    float: left;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    position: relative;
    .panel__picture {
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: -1;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      transform: rotateZ( .0001deg ) translateZ(0) translate3d(0, 0, 0);

      .filter {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    .light {
      z-index: 1;
      position: absolute;
    }

    .word {
      text-transform: uppercase;
      font-family: Gilroy;
      display: block;
      letter-spacing: .211em;
      font-size: 10vw;
      z-index: 2;
      font-weight: $global-weight-bold;
      backface-visibility: hidden;
      transform: translateZ(0);
      span {
        display: inline-block;
        transform-origin: 50% 0;
        color: $white;
      }
    }

    &--freedom {
      .panel__picture {
        background: url('../assets/img/bg_sec--1.jpg') center center / cover;
        .filter {
          background: url('../assets/img/bg_sec--1_bw.jpg') center center / cover;
        }
      }
    }
    &--happiness {
      // background: #CCC;
      .panel__picture {
        background: url('../assets/img/bg_sec--2.jpg') center center / cover;
        .filter {
          background: url('../assets/img/bg_sec--2_bw.jpg') center center / cover;
        }
      }
      .word {
        letter-spacing: .111em;
      }
    }
    &--achievement {
      .panel__picture {
        background: url('../assets/img/bg_sec--3.jpg') center center / cover;
        .filter {
          background: url('../assets/img/bg_sec--3_bw.jpg') center center / cover;
        }
      }
      .word {
        letter-spacing: .002em;
      }
    }
  }
  .icon-scroll {
    height: rem-calc(40);
    width: rem-calc(24);
    position: absolute;
    bottom: rem-calc(30);
    left: 50%;
    transform: translateX(-50%);
    border: rem-calc(2) solid $white;
    border-radius: 99em;
    &:before {
      background: $white;
      content: '';
      height: rem-calc(6);
      width: rem-calc(2);
      position: absolute;
      border-radius: 99em;
      left: 50%;
      transform: translateX(-50%) translateY(rem-calc(5));
      animation: scrollAnim 2s ease infinite;
      @at-root {
        @keyframes scrollAnim {
          0 {
            transform: translateX(-50%) translateY(rem-calc(5));
          }
          75% {
            transform: translateX(-50%) translateY(rem-calc(8));
          }
        }
      }
    }
  }
  .mxr-logo {
    margin-bottom: rem-calc(88);
    margin-left: auto;
    margin-right: auto;
    display: block;
    max-width: 78%;
    @include breakpoint(medium) {
      margin-bottom: 0;
      max-width: 100%;
    }
    &__wrap {
      align-self: flex-end;
      @include breakpoint(medium) {
        align-self: auto;
      }
    }
  }
  .home-section {
    padding: 0 rem-calc(70);
    &.section--video {
      padding: 0;
      position: relative;
      // min-height: 93vh;
    }
    &.section--1 {
      background: url('../assets/img/bg_intro.jpg') center center / cover;
      position: relative;
      z-index: 0;
      .light {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 0;
        width: 0;
        background: linear-gradient(120deg, rgba(255, 0, 120, 0) 40%, rgba(103, 58, 183, 0.10) 59%, rgba(238, 37, 116, 0.75) 87%);
        z-index: -1;
      }

      &:before {
        content: '';
        position: absolute;
        background: $white;
        height: 100%;
        width: 130%;
        top: 0;
        right: 0;
        bottom: 0;
        transform: skewX(10deg);
        transform-origin: 0 0;
        animation: slideIntro 1.3s $anim-curve forwards;

        @at-root {
          @keyframes slideIntro {
            from {
              transform: skewX(10deg) translateX(0);
            }
            to {
              transform: skewX(10deg) translateX(-100%);
            }
          }
        }
      }
    }
  }
  .section {
    &--hf {
      overflow: hidden;
      @include breakpoint(small only) {
        height: auto !important;
      }
    }
    &__title {
      position: absolute;
      bottom: 0;
      z-index: 1;
      width: 100%;
      font-size: rem-calc(14);
      font-weight: $global-weight-bold;
      text-transform: uppercase;
      letter-spacing: .511em;
      padding: rem-calc(20);
      text-align: left;
      @include breakpoint(large) {
        text-align: right;
        padding: rem-calc(40);
      }
      strong {
        display: block;
        font-family: 'Gilroy';
        letter-spacing: .5em;
        position: relative;
        font-size: rem-calc(24);
        @include breakpoint(large) {
          margin-right: -.5em;
          font-size: rem-calc(60);
          /* &:after {
            content: '';
            position: absolute;
            top: 100%;
            height: rem-calc(10);
            width: rem-calc(50);
            right: .52em;
            background: $black;
          } */
        }
      }
    }
    &--women {
      height: 100%;
      .section__inner {
        width: 100%;
        .section__picture {
          // right: 0;
          transform-origin: 100% 100%;
          &:before {
            background: url('../assets/img/bg_women.jpg') no-repeat 64% 50% / cover;
            transform-origin: 100% 100%;
          }
        }
      }
    }
    &--men {
      height: 100%;
      .section__inner {
        width: 100%;
        .section__picture {
          // left: 0;
          // transform-origin: 0 0;
          &:before {
            background: url('../assets/img/bg_men.jpg') no-repeat 33% 50%/ cover;
            transform-origin: 100% 0;
          }
        }
      }
      .section__title {
        color: $white;
        strong {
          text-shadow: rem-calc(0 5 10) rgba($black, .08);
          &:after {
            background: $white;
          }
        }
      }
    }
    &--women, &--men {
      @include breakpoint(small only) {
        height: rem-calc(580);
      }
    }
    &__inner {
      width: 100%;
      height: 100%;
      position: relative;
      display: block;
      z-index: 0;
    }
    &__picture {
      height: 100%;
      width: 100%;
      // position: absolute;
      z-index: -1;
      width: 140%;
      @include breakpoint(medium) {
        transform: skewX(10deg);
        overflow: hidden;
        width: 120%;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transition: transform .2s ease-in-out;
        @include breakpoint(medium) {
          transform: skewX(-10deg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?17cf77b2